var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"英法句子分析","placement":"bottom"}},[_c('img',{staticClass:"func-img",attrs:{"src":require("@/assets/img/note.png")},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }